import axios from "axios";
import React, { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../../doorstepServices/DoorstepServices.css"
import { ICategory, IDoorstepCategory } from "src/helper/interfaces";
import Cookies from "js-cookie";
import edit from "../../../../assets/img/icons/icons8-edit.svg"
import placeholderImg from "../../../../assets/img/landscape-placeholder-svgrepo-com.svg";
import { useNavigate, useParams } from "react-router-dom";
import { getServiceById } from "../detail_pages/DoorstepServiceDetails";
import LoadingGif from "src/components/layout/Loader";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { getAllCategories } from "../../workers/WorkersCategoriesPage";
import minusIcon from "../../../../assets/img/icons/minus-svgrepo-com.svg"

interface InitialValuesType {
   _id: string;
   about: string;
   category_name: string;
   createdAt: string; // Consider using Date type if you need date manipulation
   description: string[];
   doorstep_category_id: string;
   price_per_half_hour: string;
   price_per_hour: string;
   service_image: string | null;
   service_providers: string[];
   service_title: string;
   service_type: string;

   worker_category_id: string;
   price: string;
   working_basis: string;
   hours_count: string;
   worker_type: string;
}


const getDoorstepCategories = async (token: string, pageSize: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-categories`, {
      headers: {
         "x-access-token": token
      },
      params: {
         pageSize
      }
   })
};

type InputValues = {
   [key: string]: string;
};


const DoorstepServiceEditPage = () => {

   const initialValues: InitialValuesType = {
      _id: "",
      about: "",
      category_name: "",
      createdAt: "",
      description: [],
      doorstep_category_id: "",
      price_per_half_hour: "",
      price_per_hour: "",
      service_image: null,
      service_providers: [],
      service_title: "",
      service_type: "",

      worker_category_id: "",
      price: "",
      working_basis: "",
      hours_count: "",
      worker_type: ""

   };
   const { id } = useParams();
   const dispatch = useAppDispatch();
   const [count, setCount] = useState(1);
   const [descriptionArray, setDescriptionArray] = useState<string[]>([]);
   const [categories, setCategories] = useState<IDoorstepCategory[]>([]);
   const [professionalCategories, setProfessionalCategories] = useState<IDoorstepCategory[]>([]);
   const loading = useAppSelector(state => state.loading.value);
   const [normalService, setNormalService] = useState(true);
   const [show, setShow] = useState({
      edit: false,
      create: false
   });
   const Token = Cookies.get("token");
   const [inputValues, setInputValues] = useState<InputValues>({});
   const [selectedService, setSelectedService] = useState(initialValues);
   const [selectedValue, setSelectedValue] = useState('');
   const navigate = useNavigate();
   const handleClick = () => {
      // setCounter(counter + 1);
      setCount(count + 1)
      // console.log(counter);
   };

   let currentEndpoint = window.location.pathname;


   useEffect(() => {
      if (id && id != null) {
         getServiceById(Token as string, id as string).then((res) => {
            // console.log(res)
            if (res?.data?.status_code === 200) {
               // console.log("data: ", res?.data)
               setSelectedService(res?.data?.data);
               setCount(res?.data?.data?.description?.length);
               setDescriptionArray(res?.data?.data?.description)

            } else {
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${res?.data?.data?.msg}`,

               });
            }
         })
      }

   }, [id])

   useEffect(() => {
      const pathNameArray = currentEndpoint?.split('/');

      if (pathNameArray?.includes("professional")) {
         setNormalService(false)
      } else {
         setNormalService(true)
      }

      if (pathNameArray?.includes("edit")) {
         setShow({
            ...show,
            create: false,
            edit: true
         })
      } else {
         setShow({
            ...show,
            edit: false,
            create: true
         })
      }

   }, [currentEndpoint]);

   // useEffect(() => {
   //    console.log("normalService: ", normalService)
   // }, [normalService])

   //  this below code is for Category name 
   const handleDropdownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      setSelectedValue(event.target.value);
      setSelectedService({ ...selectedService, doorstep_category_id: event.target.value });


   };

   const handleDropdownChangeForProfessional = (event: React.ChangeEvent<HTMLSelectElement>) => {
      // setSelectedValue(event.target.value);
      setSelectedService({ ...selectedService, worker_category_id: event.target.value });


   };


   useEffect(() => {
      if (!Token) return;

      getDoorstepCategories(Token, "100").then((res) => {
         // console.log(res?.data?.data);
         if (res?.data?.status_code === 200) {
            // console.log(res?.data?.data?.data)
            setCategories(res?.data?.data?.data)
         }
      })
         .catch((err: any) => {
            console.log(err)
         })

   }, []);

   useEffect(() => {
      if (!Token) return;
      getAllCategories(Token).then((res) => {

         if (res?.data?.status_code === 200) {
            // console.log(res?.data?.data)
            const professionalCats = res?.data?.data?.filter((cat: ICategory) => (cat.type === "architect") || (cat.type === "engineer"))
            // console.log(professionalCats)
            setProfessionalCategories(professionalCats)
         }
      })
         .catch((err: any) => {
            console.log(err)
         })

   }, [])


   const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      // console.log(formInput);
      event.preventDefault();
      if (!Token) return;
      const formData = new FormData();

      // normal service
      formData.append('service_id', selectedService._id || "");
      formData.append('doorstep_category_id', selectedService.doorstep_category_id || "");
      formData.append('price_per_half_hour', selectedService.price_per_half_hour || "");
      formData.append('price_per_hour', selectedService.price_per_hour || "");
      formData.append('service_title', selectedService.service_title || "");

      // professional service
      formData.append('worker_Category_id', selectedService.worker_category_id || "");
      formData.append('price', selectedService.price || "");
      formData.append('working_basis', selectedService.working_basis?.toLocaleLowerCase() || "");
      formData.append('hours_count', selectedService.hours_count || "");

      // common
      let desArray: any[] = [];
      Object.values(descriptionArray).map((data) => {
         desArray.push(data);
      })
      if (descriptionArray.length) {
         descriptionArray.forEach((description) => {
            formData.append('service_description[]', description);
         });
      } else if (selectedService?.description && Array.isArray(selectedService.description)) {
         selectedService.description.forEach((description) => {
            formData.append('service_description[]', description);
         });
      } else {
         // Optionally append an empty field if no description is provided
         formData.append('service_description[]', '');
      }

      formData.append('about', selectedService?.about || "");


      if (selectedService.service_image) {
         formData.append('service_image', selectedService.service_image || "");
      }

      // Add new food item
      // console.log(formData)
      let formProcess = ""
      if (show.create) {
         formProcess = "post"
      }
      if (show.edit) {
         formProcess = "put"
      }
      postData(formData, formProcess)

   }

   const postData = async (data: FormData, process: string) => {
      try {
         if (process === "post") {
            dispatch(startLoading())
            await axios.post(`${AppConfig.DEV_SERVER}/${normalService ? 'doorstep-service' : 'professional/services'}`, data, {
               headers: {

                  'content-type': 'multipart/form-data',
                  "X-Access-Token": Token
               }
            }).then((res) => {
               // console.log("res: ", res?.data)
               if (res?.data?.status_code === 200) {

                  setTimeout(() => {
                     // setModalShow(false);

                     navigate(-1);
                     Swal.fire({
                        position: "center",
                        icon: "success",
                        text: `${res?.data?.msg}`,
                        title: "Success!",
                        showConfirmButton: false,
                        timer: 1800
                     })
                     dispatch(stopLoading());
                  }, 1000 * 2);
               }
               else {
                  dispatch(stopLoading());
                  Swal.fire({
                     position: "center",
                     icon: "error",
                     text: `${res?.data?.msg}`,
                     title: `Something went wrong..`,
                     showConfirmButton: false,
                     timer: 3500
                  });
               }

            }).catch((error) => {
               throw error;
            })

         }
         else {
            dispatch(startLoading())
            await axios.put(`${AppConfig.DEV_SERVER}/doorstep-service`, data, {
               headers: {
                  'content-type': 'multipart/form-data',
                  "X-Access-Token": Token
               }
            }).then((res) => {
               // console.log("res: ", res?.data)
               if (res?.data?.status_code === 200) {
                  setTimeout(() => {
                     dispatch(stopLoading());
                     // setModalShow(false);
                     navigate(-1);
                     Swal.fire({
                        position: "center",
                        icon: "success",
                        text: `${res?.data?.msg}`,
                        title: "Success!",
                        showConfirmButton: false,
                        timer: 1800
                     })
                  }, 1000 * 2);

               }
               else {
                  dispatch(stopLoading());
                  Swal.fire({
                     position: "center",
                     icon: "error",
                     text: `${res?.data?.msg}`,
                     title: "Sometthing Went Wrong...",
                     showConfirmButton: false,
                     timer: 3500
                  });
               }
            }).catch((error) => {
               throw error;
            })

         }


         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   };



   const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = event.target;
      // console.log(name, value);
      setSelectedService({ ...selectedService, [name]: value });
   }


   // const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
   //    const abc: { [key: string]: string } = {};
   //    abc[e.target.className] = e.target.value; // Error here
   //    setInputValues({ ...inputValues, ...abc });
   //    // console.log(abc)
   // };

   // const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
   //    const { name, value } = event.target;  // The name contains description-${id}
   //    // console.log(event.target)
   //    setSelectedService((prevState) => ({
   //       ...prevState,
   //       [name]: value  // Updates the specific description field based on the name
   //    }));
   // };

   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files as string | null;

      if (file && file.length !== 0) {
         setSelectedService({ ...selectedService, service_image: file[0] })
      }
   };

   const handleWorkBasisChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      setSelectedService({ ...selectedService, working_basis: event.target.value });

      // console.log(event.target.value?.toLocaleLowerCase())
   };

   const handleInputChange = (index: number, value: string) => {

      const updatedArray = [...descriptionArray];
      updatedArray[index] = value;
      setDescriptionArray(updatedArray);
   };

   return (
      <MainLayout
         showAllFilters={true}
      >
         <div className="mt-3 mb-3">

            <div className="card category-main me-2 p-3 p-md-4">
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>
                     : ""
               }
               {

                  show.edit && normalService ?
                     <form onSubmit={handleFormSubmit} className="form-div">
                        <div className="row">
                           <div className="col-6 mb-3">

                              <div className="inputs mb-2">
                                 <div className=" d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="service_title">Service Title</label>
                                    <input onChange={handleChange} value={selectedService?.service_title} name="service_title" type="text" id="service_title" aria-describedby="service_title" placeholder="Enter service Title" />
                                 </div>

                              </div>

                              <div className="inputs mb-2">
                                 <div className="d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="price_per_hour">Hourly Price</label>
                                    <input onChange={handleChange} value={selectedService?.price_per_hour} name="price_per_hour" type="text" id="price_per_hour" placeholder="Hourly Price" />
                                 </div>

                              </div>

                              <div className="inputs mb-2">
                                 <div className="d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="price_per_half_hour"> Half Hour Price</label>
                                    <input onChange={handleChange} value={selectedService?.price_per_half_hour} type="text" name="price_per_half_hour" id="price_per_half_hour" placeholder="Half Hourly Price" />
                                 </div>

                              </div>

                              <div className="inputs mb-2">
                                 <div className="d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="service_image">Service Image</label>
                                    <div className="d-flex align-items-center edit-image">
                                       <img
                                          src={
                                             selectedService?.service_image
                                                ? typeof selectedService?.service_image === 'string'
                                                   ? selectedService?.service_image
                                                   : URL.createObjectURL(selectedService?.service_image)
                                                : placeholderImg
                                          }
                                          alt="service_image"
                                       />
                                       <div className="edit-icon">
                                          <img src={edit} alt="edit-icon" />
                                          <input type="file" id="service_image" name="service_image" accept="image/png, image/jpeg, image/jpg"
                                             onChange={handleFileChange} />
                                       </div>

                                    </div>

                                 </div>
                              </div>

                              <div className="inputs mb-2">
                                 <div className=" d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="about">About</label>
                                    <textarea onChange={handleChange} name="about" style={{ width: "100%" }} form="usrform" placeholder="About Service" />
                                 </div>
                              </div>
                              <div className="inputs mb-2 ">
                                 <div className="d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="doorstep_category_id">Doorstep Category Id</label>
                                    <input onChange={handleChange} value={selectedService?.doorstep_category_id} readOnly type="text" id="doorstep_category_id" placeholder="#423453454154" />
                                 </div>

                              </div>
                              <div className="inputs mb-2 ">
                                 <div className="d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="category_name">Doorstep Category Name</label>
                                    <input onChange={handleChange} value={selectedService?.category_name} readOnly type="text" id="category_name" placeholder="Plumbing Services" />
                                 </div>

                              </div>
                           </div>
                           <div className="col-6">
                              <div className="inputs mb-2">
                                 <div className="d-flex flex-column align-items-start gap-2">
                                    <div className="d-flex justify-content-between" style={{ width: "100%", margin: "0 0 1rem 0" }}>
                                       <label htmlFor="description" className="d-flex align-items-center">Description</label>
                                       <button type="button" className="btn btn-info" onClick={handleClick}>
                                          <span>
                                             Add Field
                                          </span>
                                       </button>
                                    </div>

                                    {/* {
                                       selectedService?.description && selectedService?.description?.map((data) => {
                                          return (
                                             <input onChange={handleOnChange} value={data} type="text" id="description" name="description" placeholder="Description" className="mb-3" />
                                          )
                                       })
                                    } */}

                                    {
                                       Array.from({ length: count }, (_, i) => i + 1)?.map((index) => (
                                          <div className="d-flex gap-3 mb-2" key={index - 1} style={{ width: "100%" }}>
                                             <input
                                                type="text"
                                                name="description"
                                                id={`description-${index - 1}`}
                                                value={descriptionArray[index - 1] || ""}
                                                className="form-control"
                                                onChange={(event) => handleInputChange(index - 1, event.target.value)}
                                             />
                                             <button
                                                className="justify-content-center align-items-center"
                                                style={{ outline: "none", border: "0px", display: count === 1 ? "none" : "flex" }}
                                                onClick={() => {
                                                   if (count > 1) {
                                                      // Remove the item from descriptionArray
                                                      setDescriptionArray((prev) => prev.filter((_, idx) => idx !== index - 1));
                                                      // Decrement the count
                                                      setCount(count - 1);
                                                   }
                                                }}
                                             >
                                                <img
                                                   src={minusIcon}
                                                   alt="remove-icon"
                                                   style={{ width: "20px", height: "20px" }}
                                                />
                                             </button>
                                          </div>
                                       ))
                                    }

                                 </div>
                              </div>
                              <div className="inputs mb-2 ">
                                 <div className="d-flex flex-column align-items-start gap-2">
                                    <label htmlFor="service_providers">Service Providers</label>
                                    {
                                       selectedService?.service_providers && selectedService?.service_providers?.map((data) => {
                                          return (
                                             <input onChange={handleChange} value={data} readOnly type="text" id="service_providers" name="service_providers" placeholder="Half Hourly Price" className="mb-3" />
                                          )
                                       })
                                    }

                                 </div>

                              </div>
                           </div>
                        </div>

                        {/* button down */}
                        <div className="col-md-12 d-flex  align-items-center justify-content-end">
                           {/* <button type="button" className="btn btn-dark" onClick={() => setShow({
                              ...show,
                              edit: false
                           })}>Cancle</button> */}
                           <button type="submit" className="btn btn-primary">Submit</button>

                        </div>

                     </form> :
                     show?.edit && !normalService ?
                        <form onSubmit={handleFormSubmit} className="form-div">
                           <div className="row">
                              <div className="col-6 mb-3">

                                 <div className="inputs mb-2">
                                    <div className=" d-flex flex-column align-items-start gap-2">
                                       <label htmlFor="service_title">Service Title</label>
                                       <input onChange={handleChange} value={selectedService?.service_title} name="service_title" type="text" id="service_title" aria-describedby="service_title" placeholder="Enter service Title" required />
                                    </div>

                                 </div>
                                 <div className="inputs mb-2">
                                    <div className="d-flex flex-column align-items-start gap-2">
                                       <label htmlFor="price"> Price</label>
                                       <input onChange={handleChange} value={selectedService?.price} name="price" type="text" id="price" placeholder="Half Hourly Price" required />
                                    </div>

                                 </div>

                                 <div className="inputs mb-2">
                                    <div className="d-flex flex-column align-items-start gap-2">
                                       <label htmlFor="service_image">Service Image</label>
                                       <div className="d-flex align-items-center edit-image">
                                          <img
                                             src={
                                                selectedService?.service_image
                                                   ? typeof selectedService?.service_image === 'string'
                                                      ? selectedService?.service_image
                                                      : URL.createObjectURL(selectedService?.service_image)
                                                   : placeholderImg
                                             }
                                             alt="service_image"
                                          />
                                          <div className="edit-icon">
                                             <img src={edit} alt="edit-icon" />
                                             <input type="file" id="service_image" name="service_image" accept="image/png, image/jpeg, image/jpg"
                                                onChange={handleFileChange} />
                                          </div>

                                       </div>


                                    </div>
                                 </div>

                                 <div className="inputs mb-2">
                                    <div className=" d-flex flex-column align-items-start gap-2">
                                       <label htmlFor="serviceImage">About</label>
                                       <textarea name="about" onChange={handleChange} value={selectedService?.about} style={{ width: "100%" }} form="usrform" placeholder="About Service" />
                                    </div>
                                 </div>
                                 <div className="inputs mb-2 ">
                                    <div className="d-flex flex-column align-items-start gap-2">
                                       <label htmlFor="worker_category_id">Doorstep Category Id</label>
                                       <input onChange={handleChange} value={selectedService?.worker_category_id} readOnly type="text" id="worker_category_id" placeholder="Half Hourly Price" />
                                    </div>

                                 </div>
                                 <div className="inputs mb-2 ">
                                    <div className="d-flex flex-column align-items-start gap-2">
                                       <label htmlFor="category_name">Doorstep Category Name</label>
                                       <input onChange={handleChange} value={selectedService?.category_name} readOnly type="text" id="category_name" placeholder="Half Hourly Price" />
                                    </div>

                                 </div>
                              </div>
                              <div className="col-6">
                                 <div className="inputs  form-1 ">
                                    <div className="d-flex flex-column align-items-start">
                                       <div className="d-flex justify-content-between" style={{ width: "100%", margin: "0 0 1rem 0" }}>
                                          <label htmlFor="description" className="d-flex align-items-center">Description</label>
                                          <button type="button" className="btn btn-info" onClick={handleClick}>
                                             <span>
                                                Add Field
                                             </span>
                                          </button>
                                       </div>

                                       {/* {
                                          selectedService?.description?.map((data, id) => {
                                             return (
                                                <input
                                                   onChange={handleDescriptionChange}
                                                   key={id}
                                                   value={data || ""}
                                                   type="text"
                                                   id={`description${id}`}
                                                   name={`description-${id}`}
                                                   placeholder="Description"
                                                   className="mb-3"
                                                />
                                             )
                                          })
                                       } */}
                                       {
                                          Array.from({ length: count }, (_, i) => i + 1)?.map((index) => (
                                             <div className="d-flex gap-3 mb-2" key={index - 1} style={{ width: "100%" }}>
                                                <input
                                                   type="text"
                                                   name="description"
                                                   id={`description-${index - 1}`}
                                                   value={descriptionArray[index - 1] || ""}
                                                   className="form-control"
                                                   onChange={(event) => handleInputChange(index - 1, event.target.value)}
                                                   required
                                                />
                                                <button
                                                   className="justify-content-center align-items-center"
                                                   style={{ outline: "none", border: "0px", display: count === 1 ? "none" : "flex" }}
                                                   onClick={() => {
                                                      if (count > 1) {
                                                         // Remove the item from descriptionArray
                                                         setDescriptionArray((prev) => prev.filter((_, idx) => idx !== index - 1));
                                                         // Decrement the count
                                                         setCount(count - 1);
                                                      }
                                                   }}
                                                >
                                                   <img
                                                      src={minusIcon}
                                                      alt="remove-icon"
                                                      style={{ width: "20px", height: "20px" }}
                                                   />
                                                </button>
                                             </div>
                                          ))
                                       }
                                    </div>
                                 </div>
                              </div>
                           </div>



                           {/* button down */}
                           <div className="col-md-12 d-flex  align-items-center justify-content-between">
                              <button type="button" className="btn btn-dark" onClick={() => setShow({
                                 ...show,
                                 edit: false
                              })}>Cancle</button>
                              <button type="submit" className="btn btn-primary">Update</button>

                           </div>

                        </form> :
                        show?.create && normalService ?
                           <div>
                              <form onSubmit={handleFormSubmit} className="form-div">
                                 <div className="main-form row">
                                    <div className="col-md-6">
                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start gap-2">
                                             <label htmlFor="doorstep_category_id">Doorstep Category Id</label>
                                             <select
                                                name="doorstep_category_id"
                                                value={selectedValue}
                                                onChange={handleDropdownChange}
                                                required
                                             >
                                                <option value="">Select Category Name</option>
                                                {categories && categories.map((value, index) => (
                                                   <option key={index} value={value._id}>
                                                      {value.category_name}
                                                   </option>
                                                ))}
                                             </select>
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start gap-2">
                                             <label htmlFor="service_title">Service Title</label>
                                             <input
                                                name="service_title"
                                                required
                                                placeholder="Water Heater Installer"
                                                value={selectedService?.service_title}
                                                onChange={handleChange}

                                             />
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start gap-2">
                                             <label htmlFor="price_per_hour">Hourly Price</label>
                                             <input
                                                required
                                                name="price_per_hour"
                                                placeholder="200"
                                                value={selectedService?.price_per_hour}
                                                onChange={handleChange}
                                             />
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start gap-2">
                                             <label htmlFor="price_per_half_hour">Half Hour Price</label>
                                             <input
                                                name="price_per_half_hour"
                                                placeholder="100"
                                                required
                                                value={selectedService?.price_per_half_hour}
                                                onChange={handleChange}
                                             />
                                          </div>
                                       </div>

                                       <div className="inputs radio-sec">
                                          <div className="d-flex flex-column align-items-start">
                                             <label className="asking-div" style={{ color: "#848484" }}>
                                                Service Image
                                             </label>
                                             <input
                                                type="file"
                                                id="upload-doc"
                                                required
                                                name="upload-doc"
                                                accept="image/png, image/jpeg, image/webp"
                                                onChange={handleFileChange}
                                             />
                                          </div>
                                       </div>
                                    </div>

                                    <div className="col-md-6">
                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start gap-2">
                                             <label htmlFor="about">About</label>
                                             <textarea
                                                name="about"

                                                placeholder="Plumbing services are of Top Quality."
                                                value={selectedService?.about}
                                                onChange={handleChange}
                                             />
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start gap-2">
                                             <div className="d-flex justify-content-between" style={{ width: "100%", margin: "1rem 0px" }}>
                                                <label htmlFor="doorstepCategoryId" className="d-flex align-items-center">Service Description</label>
                                                <button type="button" className="btn btn-info" onClick={handleClick}>
                                                   <span>
                                                      Add Field
                                                   </span>
                                                </button>
                                             </div>
                                             {/* {Array.from(Array(counter)).map((c, index) => (
                                                <div key={index} style={{ width: "100%" }}>
                                                   <input
                                                      onChange={handleOnChange}
                                                      key={c}
                                                      required
                                                      className={index.toString()}
                                                      type="text"
                                                      style={{ marginBottom: "10px" }}
                                                      value={c}
                                                   />
                                                </div>
                                             ))} */}
                                             {
                                                Array.from({ length: count }, (_, i) => i + 1)?.map((index) => (
                                                   <div className="d-flex gap-3 mb-2" key={index - 1} style={{ width: "100%" }}>
                                                      <input
                                                         type="text"
                                                         name="description"
                                                         id={`description-${index - 1}`}
                                                         value={descriptionArray[index - 1] || ""}
                                                         className="form-control"
                                                         onChange={(event) => handleInputChange(index - 1, event.target.value)}
                                                         required
                                                      />
                                                      <button
                                                         className="justify-content-center align-items-center"
                                                         style={{ outline: "none", border: "0px", display: count === 1 ? "none" : "flex" }}
                                                         onClick={() => {
                                                            if (count > 1) {
                                                               // Remove the item from descriptionArray
                                                               setDescriptionArray((prev) => prev.filter((_, idx) => idx !== index - 1));
                                                               // Decrement the count
                                                               setCount(count - 1);
                                                            }
                                                         }}
                                                      >
                                                         <img
                                                            src={minusIcon}
                                                            alt="remove-icon"
                                                            style={{ width: "20px", height: "20px" }}
                                                         />
                                                      </button>
                                                   </div>
                                                ))
                                             }
                                          </div>
                                       </div>
                                    </div>

                                    <div className="col-md-12 d-flex mt-5 align-items-center justify-content-end">
                                       {/* <button type="button" className="btn btn-dark"
                                          onClick={() => {
                                             setShow({
                                                ...show,
                                                create: false
                                             });

                                          }}>Cancel</button> */}
                                       <button type="submit" className="btn btn-primary">{loading ? "Loading..." : "Submit"}</button>
                                    </div>
                                 </div>
                              </form>

                           </div>
                           : show?.create && !normalService ?
                              <div>
                                 <form onSubmit={handleFormSubmit} className="form-div">
                                    <div className="main-form row">
                                       <div className="col-md-6">
                                          <div className="inputs mb-2">
                                             <div className="d-flex flex-column align-items-start gap-2">
                                                <label htmlFor="doorstep_category_id">Doorstep Category Id</label>
                                                <select
                                                   name="doorstep_category_id"
                                                   value={selectedService?.worker_category_id}
                                                   onChange={handleDropdownChangeForProfessional}
                                                >
                                                   <option value="">Select Category Name</option>
                                                   {professionalCategories && professionalCategories.map((value, index) => (
                                                      <option key={index} value={value._id}>
                                                         {value.category_name}
                                                      </option>
                                                   ))}
                                                </select>
                                             </div>
                                          </div>

                                          <div className="inputs mb-2">
                                             <div className="d-flex flex-column align-items-start gap-2">
                                                <label htmlFor="service_title">Service Title</label>
                                                <input
                                                   name="service_title"
                                                   placeholder="Water Heater Installer"
                                                   value={selectedService.service_title}
                                                   onChange={handleChange}
                                                />
                                             </div>
                                          </div>

                                          <div className="inputs mb-2">
                                             <div className="d-flex flex-column align-items-start gap-2">
                                                <label htmlFor="price"> Price</label>
                                                <input
                                                   name="price"
                                                   placeholder="200"
                                                   value={selectedService.price}
                                                   onChange={handleChange}
                                                />
                                             </div>
                                          </div>

                                          <div className="inputs mb-2">
                                             <div className="d-flex flex-column align-items-start gap-2">
                                                <label htmlFor="working_basis">Working Basis</label>
                                                <select
                                                   name="working_basis" // Change to "working_basis"
                                                   value={selectedService?.working_basis}
                                                   onChange={handleWorkBasisChange}
                                                >
                                                   <option value="">Select Working Basis</option>
                                                   <option value="Day">Day</option> {/* Use "Day" as the value */}
                                                   <option value="Hour">Hour</option> {/* Use "Month" as the value */}
                                                </select>
                                             </div>

                                          </div>
                                          {
                                             selectedService?.working_basis === "Hour" ?
                                                <div className="inputs mb-2">
                                                   <div className="d-flex flex-column align-items-start gap-2">
                                                      <label htmlFor="hours_count">Hours Count</label>
                                                      <input
                                                         name="hours_count"
                                                         placeholder="100"
                                                         value={selectedService.hours_count}
                                                         onChange={handleChange}
                                                      />
                                                   </div>
                                                </div> :
                                                ""
                                          }


                                          <div className="inputs radio-sec">
                                             <div className="d-flex flex-column align-items-start">
                                                <label className="asking-div" style={{ color: "#848484" }}>
                                                   Service Image
                                                </label>
                                                <input
                                                   type="file"
                                                   id="upload-doc"
                                                   name="upload-doc"
                                                   accept="image/png, image/jpeg, image/webp"
                                                   onChange={handleFileChange}
                                                />
                                             </div>
                                          </div>
                                       </div>

                                       <div className="col-md-6">
                                          <div className="inputs mb-2">
                                             <div className="d-flex flex-column align-items-start gap-2">
                                                <label htmlFor="about">About</label>
                                                <textarea
                                                   name="about"
                                                   placeholder="Plumbing services are of Top Quality."
                                                   value={selectedService.about}
                                                   onChange={handleChange}
                                                />
                                             </div>
                                          </div>

                                          <div className="inputs mb-2">
                                             <div className="d-flex flex-column align-items-start gap-2">
                                                <div className="d-flex justify-content-between" style={{ width: "100%", margin: "1rem 0px" }}>
                                                   <label htmlFor="doorstepCategoryId" className="d-flex align-items-center">
                                                      Service Description
                                                   </label>
                                                   <button type="button" className="btn btn-info" onClick={handleClick}>
                                                      <span>
                                                         Add Field
                                                      </span>
                                                   </button>
                                                </div>

                                                {
                                                   Array.from({ length: count }, (_, i) => i + 1)?.map((index) => (
                                                      <div className="d-flex gap-3 mb-2" key={index - 1} style={{ width: "100%" }}>
                                                         <input
                                                            type="text"
                                                            name="description"
                                                            id={`description-${index - 1}`}
                                                            value={descriptionArray[index - 1] || ""}
                                                            className="form-control"
                                                            onChange={(event) => handleInputChange(index - 1, event.target.value)}
                                                            required
                                                         />
                                                         <button
                                                            className="justify-content-center align-items-center"
                                                            style={{ outline: "none", border: "0px", display: count === 1 ? "none" : "flex" }}
                                                            onClick={() => {
                                                               if (count > 1) {
                                                                  // Remove the item from descriptionArray
                                                                  setDescriptionArray((prev) => prev.filter((_, idx) => idx !== index - 1));
                                                                  // Decrement the count
                                                                  setCount(count - 1);
                                                               }
                                                            }}
                                                         >
                                                            <img
                                                               src={minusIcon}
                                                               alt="remove-icon"
                                                               style={{ width: "20px", height: "20px" }}
                                                            />
                                                         </button>
                                                      </div>
                                                   ))
                                                }
                                             </div>
                                          </div>
                                       </div>

                                       {/* <div className="col-md-12 d-flex mt-5 align-items-center justify-content-between">
                                          <button type="button" className="btn btn-dark" onClick={() => setShow({
                                             ...show,
                                             create: false
                                          })}>Cancel</button>
                                          <button type="submit" className="btn btn-primary">{loading ? "Loading..." : "Submit"}</button>
                                       </div> */}
                                    </div>
                                 </form>

                              </div> : ''
               }

            </div>

         </div>

      </MainLayout>
   )

};



export default DoorstepServiceEditPage;